import { render } from "./SnsShareLinks.vue?vue&type=template&id=1070bc9c"
import script from "./SnsShareLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./SnsShareLinks.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SnsShareLinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1070bc9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1070bc9c', __exports__)) {
    api.reload('1070bc9c', __exports__)
  }
  
  module.hot.accept("./SnsShareLinks.vue?vue&type=template&id=1070bc9c", () => {
    api.rerender('1070bc9c', render)
  })

}


export default __exports__